import '../stylesheets/default-ocean-blue.css';
import '../stylesheets/style.scss';
import '@fortawesome/fontawesome-free/js/all.min.js';
import '@progress/kendo-ui/esm/kendo.textarea.js';
import '@progress/kendo-ui/esm/kendo.window.js';
import '@progress/kendo-ui/esm/kendo.chat.js';
import '@progress/kendo-ui/esm/kendo.tooltip.js';
import '@progress/kendo-ui/esm/kendo.button.js';
import '@progress/kendo-ui/esm/kendo.dialog.js';
import '@progress/kendo-ui/esm/kendo.wizard.js';
import './kendo-ui/kendo-ui-license.js';
import './i18nSetup.js';
import '../audio/bell.mp3';
import '../audio/calling.mp3';
import '../images/camera.svg';
import '../images/camera_icon.svg';
import '../images/microphone.svg';
import '../images/net_speed.svg';
import '../images/speaker.svg';
import '../images/step_error.svg';
import '../images/sys_check_steps.png';
import '../images/user_icon.svg';
import RTPaaSProctor from './main/RTPaaSProctor.js';
import RTPaaSTester from './main/RTPaaSTester.js';
import SystemCheck from './systemCheck/SystemCheck.js';

window.$k = kendo.jQuery.noConflict();
export {RTPaaSProctor, RTPaaSTester, SystemCheck};
